<template>
  <div id="mapbox" class="mapa"></div>
</template>

<script>
var mapboxgl = require("mapbox-gl/dist/mapbox-gl.js");

mapboxgl.accessToken =
  "pk.eyJ1IjoiZG9nY2FsYXMiLCJhIjoiY2p1MDdjb2Q4MW1mMzRkcGZleWM0cmd5eiJ9.HSK77-donn1vBcZyHSV4Hg";

export default {
  name: "Mapbox",

  components: {},
  props: ["autosearch"],
  mounted() {
    const me = this;

    this.map = new mapboxgl.Map({
      container: "mapbox",
      style: "mapbox://styles/mapbox/streets-v11",
      center: [-79.897469, -2.1335],
      zoom: 13
    });
    this.geocontrol = new mapboxgl.GeolocateControl({
      positionOptions: {
        enableHighAccuracy: true
      },
      trackUserLocation: false,
      showUserLocation: false
    });
    this.map.addControl(this.geocontrol);
    this.map.on("load", function() {
      me.marker = new mapboxgl.Marker({}).setLngLat(me.map.getCenter()).addTo(me.map);
      me.map.on("move", function() {
        me.marker.setLngLat(me.map.getCenter());
      });
      me.map.on("moveend", function() {
        me.onDragEnd();
      });
    });
    this.geocontrol.on("geolocate", function(position) {
      me.animateMarker([position.coords.longitude, position.coords.latitude]);
    });
  },
  methods: {
    updateSize() {
      this.map.resize();
      this.resized = true;
      if (!this.autosearch || this.autosearch.lat==0) {
        this.geocontrol.trigger();
      } else {
        this.animateMarker([this.autosearch.lng, this.autosearch.lat]);
      }
    },
    onDragEnd() {
      if (this.resized) {
        this.$emit("coordinates", this.marker.getLngLat());
      }
    },
    unresize() {
      this.resized = false;
    },
    animateMarker(coordinates) {
      const me = this;
      me.marker.getElement().classList.add("move");
      me.marker.setLngLat(coordinates);
      me.map.flyTo({center: coordinates})
      me.$emit("coordinates", {
        lat: coordinates[1],
        lng: coordinates[0]
      });
      setTimeout(() => {
        me.marker.getElement().classList.remove("move");
      }, 501);
    }
  },
  data: () => ({
    resized: false,
    map: null,
    geocontrol: null,
    marker: null
  })
};
</script>

<style scoped>
.mapa {
  position: relative;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 75vh;
}

.move {
  transition: all 0.5s ease-out;
}
</style>